import React from "react";
import {Outlet} from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AppDialog from "../components/AppDialog";

const MainLayout = () => (
    <div className="pb-page">
        <Header/>
        <main>
            <Outlet/>
        </main>
        <Footer/>
        <AppDialog/>
    </div>
);

export default MainLayout;
